import { render, staticRenderFns } from "./ButtonUpgrade.vue?vue&type=template&id=0edf55aa&scoped=true&"
import script from "./ButtonUpgrade.vue?vue&type=script&lang=js&"
export * from "./ButtonUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./ButtonUpgrade.vue?vue&type=style&index=0&id=0edf55aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf55aa",
  null
  
)

export default component.exports